import React from "react"
interface Props {
  size: number
}

const savingsIconHref = "https://res.cloudinary.com/perkbox/image/upload/v1708606791/94f1d73c-2210-4ae2-a0f5-a54cc189c913.gif"

const SavingsAnimated = (props: Props) => {
  const {size} = props
  return <img src={savingsIconHref} width={size} height={size} {...props} />
}

export default SavingsAnimated
